// extracted by mini-css-extract-plugin
export default {"checkButton":"Mrq3drTo dim-button"};